
import { fetchJson } from './fetchJson';
import Cookies from 'js-cookie';
import { API_BASE_URL } from "../config";

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return '';
}
export const getDaynamicData = async (menu_id) => {
  try {
    const res = await fetchJson(`${API_BASE_URL}/dynamicFormDataList`, {
          method:'POST',
          body: JSON.stringify({pluginId:menu_id}),
          headers: {
            'Content-Type': 'application/json',
            token: Cookies.get('_bb_key'),
            SadminID: Cookies.get('authid'),
          },
        });
        return res;
  } catch (err) {
      console.error('Failed to fetch slides:', err);
      return { flag: 'F', msg: 'API Error' };
  }
};

export const logout = () => {
  Cookies.remove('token');
  Cookies.remove('authid');
  Cookies.remove('_bb_key');
  localStorage.removeItem('user');
  sessionStorage.clear();
  localStorage.removeItem('active_company');
  localStorage.removeItem('companyList')
  localStorage.removeItem('gfcmt');
  localStorage.removeItem('appMenu');
  localStorage.clear();
  
  
  // ...clear anything else you store during login
};

export const getCompanyList = async () => {
  if (localStorage.getItem('companyListFetched') === 'true') {
    return JSON.parse(localStorage.getItem('companyList') || '[]');
  }

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const allowedCompanyIds = (user.company_id || '').split(',');

  const res = await fetchJson(`${API_BASE_URL}/getCompanyList`, {
    method: 'GET',
    headers: {
      'token': Cookies.get('_bb_key'),
      'SadminID': Cookies.get('authid'),
    }
  });
  if (res.flag === 'S') {
    const filtered = res.data.filter(company =>
      allowedCompanyIds.includes(company.infoID.toString())
    );

    localStorage.setItem('companyListFetched', 'true');
    localStorage.setItem('companyList', JSON.stringify(filtered));

    return filtered;
  }

  return [];
};

export function formatLabel(str) {
  if (!str) return '';

  return str
    .replace(/_/g, ' ') // Replace underscores with spaces
    .split(' ')         // Split into words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(' ');         // Join back with space
}
